
import TableList from "@components/templates/tablelist";
import compDetail from './update';
import { HttpInboundList, HttpExportInbound, HttpCancelInbound, HttpSubmitInbound} from "@/service/allotment";
import { mapGetters } from "vuex";
import mixin from "../mixin";
export default {
    mixins: [TableList, mixin],
    components: {
        compDetail,

    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                    EQ_transferOutboundStatus: null,
                }
            },
            Searchs: {
                show: true,
                labelWidth: 110,
            },
            Plugins: { show: true }
        };
    },
    methods: {
        ajaxRequest: HttpInboundList,
        interceptRequest(params) {
            const { inWarehouseId } = params.search;
            params.inWarehouseId = inWarehouseId;
           /*  if (params.search.quanbu === 0) {
                params.search.EQ_transferOutboundStatus = '';
            }
            if (params.search.error === 1) {
                params.search.IN_errorCode = [1,2];
            }else if(params.search.error === 3){
                params.search.IN_errorCode = [3,4];
            }else if(params.search.error === 5){
                params.search.EQ_errorCode = 5;
            }else if(params.search.error === 7){
                params.search.IN_errorCode = [6,7];
            }else if(params.search.error === 8){
                params.search.IN_errorCode = [8,9];
            }else if(params.search.error === 11){
                params.search.IN_errorCode = [11,12];
            }else if(params.search.error === 14){
                params.search.IN_errorCode = [14,15];
            }else if(params.search.error === 18){
                params.search.EQ_errorCode = 18;
            }else if(params.search.error === 19){
                params.search.IN_errorCode = [19,20];
            }
            delete params.search.error;
            delete params.search.quanbu */

            delete params.search.inWarehouseId;
            return params
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case "edit":
                    this.$router.push({
                        name: 'allotUpdateInbound',
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    break;
                    case "query":
                    this.operate = {
                        title: this.$t('fbb.alloment.detail', { defaultValue: '详情' }),
                        show: true,
                        width: 1200,
                        component: "compDetail",
                        activeid: params,
                        querytype: 'query',
                        showFooter: false
                    }
                 break;
            case "queryBlank":
                    var url = this.$router.resolve({
                        name: "allotUpdateInbound",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "add":
                    this.$router.push({
                        name: 'allotUpdateInbound',
                        params: { type: "add" },
                    });
                    break;
                case "submit":
                    this.operate = {
                        show: true,
                        alert: "success",
                        params: { transferInboundId: params },
                        title: this.$t('global.common.update_submit', { defaultValue: "提交" }),
                        ajaxRequest: HttpSubmitInbound
                    }
                    break;
                case "cancel":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t('global.common.operate_cancel', { defaultValue: "取消" }),
                        width: 'middle',
                        showDesc: false,
                        params: {
                            transferInboundId: params
                        },
                        ajaxRequest: HttpCancelInbound,
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "reason",
                                span: 24,
                                label: this.$t('fbb.alloment.cancel_reason', { defaultValue: "取消原因" })
                            }
                        ]
                    };
                    break;
                   /*  case 'reprocess':
                        this.operate = {
                            show: true,
                            alert: "error",
                            title: "重处理",
                            width: 400,
                            showDesc: true,
                            params: {
                                id: params,
                                type:4
                            },
                            ajaxRequest: HttpReprocessPlanBill,
                        };
                        break;
                        case 'backToNormal':
                            this.operate = {
                                show: true,
                                alert: "info",
                                title: "忽略异常",
                                width: 400,
                                showDesc: true,
                                params: {
                                    id: params,
                                    type:4
                                },
                                ajaxRequest: HttpBackToNormalPlanBill,
                            };
                            break; */
                case 'export':
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/TransferInbound/batchExport', this.formData, {
                        executor: 'request',
                        download: true,
                        method: 'post',
                    })
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id, transferInboundOrderStatus: status ,errorCode} = row
            return [{
                label: this.$t('fbb.alloment.query_detail', { defaultValue: '查看详情' }),
                show: true,
                params: id,
                operate: 'query'
            }, {
                label: this.$t('global.common.edit', { defaultValue: '编辑' }),
                show: status == 0 || status == 3,
                params: id,
                operate: 'edit'
            }, {
                label: this.$t('global.common.update_submit', { defaultValue: '提交' }),
                show: status == 0 || status == 3,
                params: id,
                operate: 'submit'
            }, {
                label: this.$t('global.common.operate_cancel', { defaultValue: '取消' }),
                show: status == 0 || status == 5 || status == 10,
                params: id,
                operate: 'cancel'
            }
           /*  , {
                label: '重处理',
                show: errorCode !== 0,
                params: id,
                operate: 'reprocess'
            }, {
                label: '忽略异常',
                show: errorCode !== 0,
                params: id,
                operate: 'backToNormal'
            } */]
        }
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusWareList', 'getBillcusAndFbaWareList','getUserManageWarehouseList','getSelfmanageorgList','getOrgList']),
        getBillStatus() {
            // DRAFT(0, "草稿"),
            //     APPOINTMENT(5, "已预约"),
            //     COMPLETED(70, "已完成"),
            //     CLOSED(90, "已关闭");
            return [{
                label: this.$t('fbb.alloment.draft', { defaultValue: "草稿" }),
                value: 0
            }, {
                label: this.$t('fbb.alloment.has_appointed', { defaultValue: "已预约" }),
                value: 5,
                theme: 'info'
            }, {
                label: this.$t('global.common.finished', { defaultValue: "已完成" }),
                value: 70,
                theme: 'success'
            }, {
                label: this.$t('global.common.canceled', { defaultValue: "已取消" }),
                value: 90,
                theme: 'error'
            }]
        },
        TabsData() {
            return [
                {
                    label: this.$t('fbb.alloment.all', { defaultValue: "所有" }),
                    key: 'EQ_transferInboundOrderStatus',
                    value: null
                }, {
                    label: this.$t('fbb.alloment.wait_for_commit', { defaultValue: "待提交" }),
                    key: 'EQ_transferInboundOrderStatus',
                    value: 0
                }, {
                    label: this.$t('global.common.canceled', { defaultValue: "已取消" }),
                    key: 'EQ_transferInboundOrderStatus',
                    value: 90
                }/* , {
                    name: "异常单据",
                    key: 'NE_errorCode',
                    value: 0
                } */
            ]
        },
        ToolsData() {
            return [
                {
                    name: this.$t('global.common.add', { defaultValue: "添加" }),
                    operate: "add",
                    theme: "primary",
                }, {
                    name: this.$t('global.common.export', { defaultValue: "导出" }),
                    operate: "export",
                    theme: "info",
                    // batch: true,
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('fbb.alloment.inbound_order_number', { defaultValue: "调拨入库单号" }),
                    tag: 'vInput',
                    key: 'EQ_transferInboundOrderNo',
                    show: true,
                },
                {
                    label: this.$t('fbb.alloment.alloment_order_number', { defaultValue: "调拨计划单号" }),
                    tag: 'vInput',
                    key: 'CN_transferOutboundPlanNo',
                    show: true,
                },
                {
                    label: this.$t('global.common.warehouse', { defaultValue: "仓库" }),
                    tag: 'vSelect',
                    key: 'EQ_orgWarehouseCode',
                    show: true,
                    options: this.getUserManageWarehouseList,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('global.common.organization', { defaultValue: "组织" }),
                    tag: 'vSelect',
                    key: 'EQ_organizationId',
                    options: this.getSelfmanageorgList,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('global.common.source_number', { defaultValue: "来源单号" }),
                    tag: 'vInput',
                    key: 'EQ_sourceNo',
                },
                /* {
                    label: "异常类型",
                    tag: 'vSelect',
                    key: 'error',
                    options: this.getErrorSimpleType,
                }, */
                {
                    label: this.$t('global.common.createdtime', { defaultValue: "创建时间" }),
                    tag: 'vDatepicker',
                    style: "width:362px",
                    key: 'BT_createdAt',
                    props: {
                        format: 'yy-mm-dd 00:00:00~yy-mm-dd 23:59:59',
                        confirm: false,
                    },
                }
            ]
        },
        columns() {
            return [{
                type: 'selection',
                width: 40,
                align: 'center',
                formName: 'id'
            }, {
                title: this.$t('global.common.operation', { defaultValue: '操作' }),
                maxWidth: 90,
                render: this.getOperateNodes
            }, {
                title: this.$t('global.common.organization', { defaultValue: '组织' }),
                key: 'orgName',
                // render: (h, { row }) => this.findRenderLabel(this.getOrgList, row.organizationId)
            },
            {
                title: this.$t('fbb.alloment.inbound_order_number', { defaultValue: '调拨入库单号' }),
                key: 'transferInboundOrderNo',
                render: (h, { row }) => {
                    return <div><a class="color-link" onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.transferInboundOrderNo}</a><a onClick = {
                        this.handleOperates.bind(this, row.id, 'queryBlank')
                    } > < vIcon class = "margin-left-10 font-14"
                    type = "ios-browsers-outline" /> </a>
                    {/* <br/><div><span style="color:red;">{this.findRenderLabel(this.getErrorType, row.errorCode)} </span> </div> */}
                    </div>
                }
            },
            {
                title: this.$t('fbb.alloment.alloment_order_number', { defaultValue: '调拨计划单号' }),
                key: 'transferOutboundPlanNo',
            },
            {
                title: this.$t('fbb.alloment.warehouse_in', { defaultValue: '入库仓库' }),
                key: 'orgWarehouseCode',
                // render: (h, { row }) => this.findRenderLabel(this.getBillcusWareList, row.orgWarehouseId)
            },
            {
                title: this.$t('global.common.source_number', { defaultValue: '来源单号' }),
                key: 'sourceNo',
            },
            {
                title: this.$t('fbb.alloment.order_status', { defaultValue: '单据状态' }),
                key: 'transferInboundOrderStatus',
                maxWidth: 80,
                render: (h, { row }) => {
                    const status = row.transferInboundOrderStatus;
                    const { theme = 'default', label } = this.getBillStatus.find(function (item) {
                        return item.value == status
                    }) || {};
                    return <vButton ghost theme={theme} size="small" class="cursor-not width-60">{label}</vButton>
                }
            },
            {
                title: this.$t('global.common.createdtime', { defaultValue: '创建时间' }),
                key: 'createdAt',
                sortable: true
            },
            ];
        },

    },

};
